module.exports = __webpack_public_path__ + "img/Ru-T200.47c9ba0a.gif";